import Auth from '@/api/auth'
import http from '@/api/http'

interface State {
  token: string
  isBan: boolean
}

interface LoginPayload {
  user_id: string
  password: string
  history_id: string
  callback: (data: any) => void
}

const defaultState: State = {
  token: '',
  isBan: false
}

const state: State = Object.assign({}, defaultState)

const mutations = {
  resetState(state: State) {
    const s = defaultState
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },

  setToken(state: State, token: string) {
    state.token = token
  },

  setIsBan(state: State, isBan: boolean) {
    state.isBan = isBan
  }
}

const actions = {
  /**
   * SMS 認証の必要性を確認
   */
  shouldSmsAuth({}, payload: any): Promise<any> {
    return Auth.shouldSmsAuth(payload).catch(err => {
      throw err
    })
  },

  /**
   * 登録処理
   */
  signup({ commit }, payload: any): Promise<any> {
    return Auth.signup(payload)
      .then(data => {
        data.token = data.token || ''
        commit('setToken', data.token)
        return data
      })
      .catch(err => {
        throw err
      })
  },

  /**
   * ログイン
   */
  login({ commit }, payload: LoginPayload): Promise<any> {
    const params = {
      user_id: payload.user_id,
      password: payload.password
    }
    if (payload.history_id) {
      params['history_id'] = payload.history_id
    }

    return Auth.login(params)
      .then(data => {
        if (data.error) {
          return data
        }
        if (data.token) {
          commit('setToken', data.token)
        }
        if (typeof payload.callback === 'function') {
          payload.callback(data)
        }
      })
      .catch(err => {
        throw err
      })
  },

  /**
   * ログアウト
   */
  logout({ commit }) {
    http.defaults.headers.common['TOKEN'] = ''
    localStorage.removeItem('vuex')
    commit('setIsBan', false)
    commit('setToken', '')
  },

  /**
   * トークンを確認する
   */
  verifyToken({ state, commit, dispatch }): Promise<boolean> {
    return Auth.verifyToken(state.token)
      .then(({ result, error }) => {
        if (result === 'OK') {
          commit('setIsBan', false)
          return true
        }

        if (error && error.code) {
          if (error.code === 2) {
            commit('setIsBan', true)
          } else if (error.code === 1) {
            dispatch('logout')
          }
        }
        return false
      })
      .catch(err => {
        throw err
      })
  },

  /**
   * 認証情報を取得
   */
  fetchAuthInfo(payload: any): Promise<{ user_id: string; password: string; history_id: string }> {
    return Auth.fetchAuthInfo(payload)
  },

  /**
   * ポイント合算対象者かチェック
   */
  checkPointAddUp({}, userId: string): Promise<any> {
    return Auth.checkPointAddUp({
      page: 'get_init',
      from_user: userId
    })
      .then(({ point }) => {
        if (point) {
          return {
            canGassan: true,
            addPoint: point
          }
        }
        return {
          canGassan: false
        }
      })
      .catch(err => {
        throw err
      })
  },

  /**
   * ポイント合算
   */
  addUpPoint({}, userId: string): Promise<any> {
    return Auth.addUpPoint({
      page: 'add_up',
      from_user: userId
    }).catch(err => {
      throw err
    })
  }
}

const getters = {
  token: (state: State): string => state.token,
  isBan: (state: State): boolean => state.isBan
}

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
